import styled from 'styled-components'
import { breakpoints, theme } from '../builderUtils/theme'

export const BlockContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem 0; /* Only vertical padding */
  width: 100%;
  background-color: ${theme.cream};
  min-height: 216px;
  max-width: 600px; /* or whatever you prefer */
  margin: 0 auto;

  @media (max-width: ${breakpoints.m}px) {
    padding: 2.5rem 1.25rem; /* py-10 px-5 */
    max-width: 100%;
  }
`
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Heading = styled.h2`
  font-family: 'FilsonPro';
  font-size: 33px; /* text-4xl */
  font-weight: 700; /* font-bold */
  color: ${theme.onboardGray};
  text-align: center;
  margin-bottom: 0.1rem;
  width: 100%;

  @media (max-width: ${breakpoints.m}px) {
    font-size: 26px;
    font-style: normal;
    line-height: 150%; /* 43.2px */
    letter-spacing: -0.76px;
    text-align: center;
  }
`
export const Description = styled.p`
  font-family: 'FilsonPro';
  margin-top: 24px;
  font-size: 24px;
  font-weight: 400;
  line-height: 150%; /* 36px */
  color: ${theme.onboardGray};
  text-align: center;
  @media (max-width: ${breakpoints.m}px) {
    font-size: 16px;
  }
`

export const CTAButtonWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;

  margin-top: 35px;
  width: 100%;

  @media (max-width: ${breakpoints.m}px) {
    margin-top: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`
export const CTAButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: ${(props) => (props.description ? '1rem' : '2rem')};
`

export const CTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`
